import { createApp } from 'vue'
import { vMaska } from 'maska/vue'
//import { Modal, OrugaConfig } from '@oruga-ui/oruga-next'
import AppointmentForm from './AppointmentForm.vue'
import AppointmentTrigger from './AppointmentTrigger.vue'

export { createSchema } from './schema'

/**
 * Монтирование формы в конкретный элемент.
 * Надо указать точный идентификатор. Например, `#callback `.
 *
 * Для отображения на странице.
 */
/*export function mountForm(id: string = '#order') {
  if (!document.querySelector(id)) return

  return createApp(OrderForm)
    .directive('maska', vMaska)
    .mount(`${id}`)
}*/

/**
 * Для "рисования" компонентов необходимо подключать
 * полную версию Vue, включающую runtime compiler. Для
 * этого в конфигурации `vite.config.ts`.
 *
 * ```ts
 * export default defineConfig({
 *   resolve: {
 *     alias: {
 *       vue: 'vue/dist/vue.esm-bundler.js'
 *     }
 *   }
 * })
 * ```
 *
 */
export function renderAppointmentForm(selector: string = '.appointment-form-render') {
  const _elements = document.querySelectorAll(selector)

  _elements.forEach((x: Element): void => {
    createApp({
      setup() {
        console.log('render appointment form')
      }
    })
      .component('appointment-form', AppointmentForm)
      .directive('maska', vMaska)
      .mount(x)
  })
}

/**
 * Монтирование, только один компонент как приложение.
 */
/*export function mountTrigger(selector: string) {
  const _elements = document.querySelectorAll(selector)

  _elements.forEach((x: Element): void => {
    createApp(OrderTrigger, {
      title: 'Обратный звонок',
      showIcon: false
    })
      .directive('maska', vMaska)
      // .use(Oruga, {})
      .use(OrugaConfig, {})
      .use(Modal) // or single component .component(OModal)
      .mount(x)
  })
}*/

/**
 * Компиляция "на лету", если необходимо передать
 * параметры или рисовать динамические данные от CMS/PHP.
 *
 * ```
 * <div class="order-trigger-render">
 *   <order-trigger title="<?= $title ?>" :show-icon="false">
 *     ...
 *   </order-trigger>
 * </div>
 * ```
 */
/*export function renderTrigger(selector: string) {
  const _elements = document.querySelectorAll(selector)

  _elements.forEach((x: Element): void => {
    createApp({
      setup() {
        console.log('render order trigger')
      }
    })
      .component('order-trigger', OrderTrigger)
      .directive('maska', vMaska)
      // .use(Oruga, {}) // Это подключение всех компонентов!
      .use(OrugaConfig, {}) // Для работы программного интерфейса
      .use(Modal) // Только необходимый компонент. (.component(OModal))
      .mount(x)
  })
}*/

export {
  AppointmentForm,
  AppointmentTrigger
}
